function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M332.441,197.182c-0.66,0-1.31-0.07-1.96-0.2c-0.64-0.13-1.26-0.32-1.87-0.57c-0.6-0.25-1.18-0.56-1.72-0.92 c-0.55-0.36-1.06-0.78-1.52-1.24c-0.47-0.46-0.88-0.97-1.25-1.52c-0.36-0.54-0.67-1.13-0.92-1.73c-0.25-0.6-0.44-1.23-0.57-1.87 s-0.19-1.3-0.19-1.95s0.06-1.31,0.19-1.96c0.13-0.63,0.32-1.26,0.57-1.87c0.25-0.6,0.56-1.18,0.92-1.72 c0.37-0.55,0.78-1.06,1.25-1.52c0.46-0.47,0.97-0.88,1.52-1.25c0.54-0.36,1.12-0.67,1.72-0.92c0.61-0.25,1.23-0.44,1.87-0.57 c1.29-0.26,2.62-0.26,3.91,0c0.64,0.13,1.27,0.32,1.87,0.57s1.19,0.56,1.73,0.92c0.55,0.37,1.06,0.78,1.52,1.25 c0.46,0.46,0.88,0.97,1.24,1.52c0.36,0.54,0.67,1.12,0.92,1.72c0.25,0.61,0.44,1.24,0.57,1.87c0.13,0.65,0.2,1.31,0.2,1.96 c0,0.65-0.07,1.31-0.2,1.95s-0.32,1.27-0.57,1.87c-0.25,0.6-0.56,1.19-0.92,1.73c-0.36,0.55-0.78,1.06-1.24,1.52 s-0.97,0.88-1.52,1.24c-0.54,0.36-1.13,0.67-1.73,0.92s-1.23,0.44-1.87,0.57C333.751,197.112,333.091,197.182,332.441,197.182z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M509.007,460.031l-39.615-39.626l31.631-31.64c3.904-3.905,3.904-10.235,0-14.141L466.108,339.7 c-1.875-1.875-4.419-2.93-7.072-2.93c-2.653,0-5.197,1.054-7.072,2.93l-19.566,19.571l-29.029-29.038 c15.646-32.905,23.774-68.871,23.774-106.06v-66.184L498.2,86.912c1.501-1.502,2.485-3.443,2.81-5.541l10.807-69.841 c0.488-3.151-0.557-6.346-2.812-8.601s-5.452-3.3-8.601-2.811l-69.823,10.81c-2.099,0.325-4.041,1.31-5.542,2.812L340.16,98.643 c-28.321-11.396-54.301-27.724-77.713-48.884c-3.734-3.374-9.394-3.449-13.215-0.173c-11.111,9.527-23.061,18.309-35.518,26.101 c-13.838,8.654-28.119,16.008-42.784,22.044l-83.967-83.99c-1.502-1.502-3.443-2.487-5.542-2.812L11.598,0.12 c-3.15-0.49-6.346,0.556-8.601,2.811c-2.254,2.254-3.299,5.449-2.811,8.6l10.807,69.841c0.325,2.098,1.309,4.039,2.81,5.541 L84.86,157.99v66.184c0,37.189,8.128,73.155,23.774,106.06l-29.029,29.037L60.039,339.7c-1.875-1.876-4.419-2.93-7.072-2.93 s-5.197,1.054-7.072,2.93L10.98,374.624c-3.904,3.905-3.904,10.235,0,14.141l31.631,31.64L2.996,460.031 c-3.904,3.905-3.904,10.235,0,14.141l34.891,34.9c1.875,1.876,4.419,2.93,7.072,2.93s5.197-1.054,7.072-2.93l39.612-39.622 l31.628,31.636c1.875,1.875,4.419,2.93,7.072,2.93s5.197-1.054,7.072-2.93l34.915-34.924c3.904-3.905,3.904-10.235,0-14.141 l-19.569-19.575l18.594-18.599c24.971,23.002,52.79,40.357,81.323,50.409c1.075,0.379,2.199,0.568,3.323,0.568 s2.248-0.189,3.323-0.568c28.535-10.053,56.354-27.409,81.324-50.409l18.594,18.599l-19.569,19.575 c-3.904,3.905-3.904,10.235,0,14.141l34.915,34.924c1.875,1.876,4.419,2.93,7.072,2.93s5.197-1.054,7.072-2.93l31.628-31.636 l39.612,39.622c1.875,1.876,4.419,2.93,7.072,2.93s5.197-1.054,7.072-2.93l34.891-34.9 C512.911,470.266,512.911,463.936,509.007,460.031z M436.873,30.194l53.09-8.219l-8.218,53.11l-54.602,54.616v-2.719 c0-5.179-3.954-9.5-9.112-9.96c-19.824-1.768-38.832-5.441-56.972-10.994L436.873,30.194z M30.258,75.084l-8.218-53.11l53.09,8.219 l75.085,75.106c-18.28,5.851-37.09,9.732-56.326,11.607c-5.123,0.499-9.03,4.806-9.03,9.953v2.843L30.258,75.084z M44.959,487.858 l-20.751-20.757l32.543-32.552l20.751,20.756L44.959,487.858z M130.343,479.872l-98.15-98.177l20.774-20.78l98.151,98.177 L130.343,479.872z M93.745,373.415l24.671-24.678c4.662,7.983,9.794,15.749,15.387,23.268c7.328,9.85,15.13,19.135,23.319,27.79 l-18.502,18.507L93.745,373.415z M256,444.184c-39.01-14.632-76.589-44.382-106.151-84.117 c-29.433-39.57-44.99-86.562-44.99-135.894v-88.382c42.18-5.43,82.326-19.924,119.46-43.146 c10.841-6.781,21.322-14.265,31.253-22.309c43.185,36.816,94.096,58.872,151.57,65.663v88.174 c0,49.333-15.558,96.325-44.991,135.896C332.593,399.801,295.014,429.55,256,444.184z M373.383,418.303l-18.501-18.507 c8.189-8.654,15.99-17.939,23.318-27.788c5.593-7.52,10.726-15.287,15.388-23.27l24.671,24.678L373.383,418.303L373.383,418.303z  M381.66,479.872l-20.775-20.78l98.151-98.177l20.774,20.78L381.66,479.872z M467.043,487.858L434.5,455.306l20.751-20.756 l32.543,32.552L467.043,487.858z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M387.419,224.177v-25.676c0-0.546-0.044-1.082-0.129-1.605c0.085-0.524,0.129-1.057,0.129-1.595V161.39 c0-4.771-3.371-8.878-8.051-9.808c-19.425-3.86-38.36-9.557-56.28-16.935c-0.005-0.002-0.011-0.005-0.016-0.007 c-21.833-8.982-42.703-20.705-62.031-34.841c-3.455-2.525-8.134-2.574-11.64-0.119c-4.872,3.412-9.793,6.673-14.632,9.696 c-32.023,20.034-66.432,34.066-102.271,41.708c-4.615,0.984-7.915,5.061-7.915,9.78v63.313c0,31.418,6.798,61.542,20.206,89.535 c0.005,0.01,0.01,0.02,0.015,0.03c5.753,12.044,12.771,23.667,20.866,34.553c8.489,11.394,17.73,21.993,27.465,31.504l0,0l0,0 c18.349,17.923,38.095,31.811,58.689,41.277c1.326,0.609,2.75,0.914,4.176,0.914s2.852-0.305,4.177-0.914 c31.818-14.629,61.608-39.798,86.148-72.787C373.21,312.153,387.419,269.236,387.419,224.177z M157.134,291.921 c-8.335-21.479-12.551-44.204-12.551-67.744v-55.323c35.276-8.439,69.146-22.724,100.788-42.519c3.194-1.996,6.423-4.089,9.65-6.257 c14.879,10.384,30.567,19.451,46.84,27.077L157.134,291.921z M321.681,155.619c14.744,5.704,30.071,10.354,45.739,13.875v21.666 L200.19,358.435c-3.974-4.225-7.843-8.648-11.585-13.24l122.818-122.852c3.904-3.906,3.904-10.238-0.002-14.143 c-3.905-3.903-10.237-3.903-14.143,0.002l-120.766,120.8c-3.843-5.71-7.364-11.607-10.533-17.64L321.681,155.619z M256.001,400.909 c-14.328-7.1-28.239-16.657-41.496-28.505l152.914-152.956v4.729c0,40.726-12.842,79.515-37.139,112.174 C308.829,365.187,283.227,387.421,256.001,400.909z"
});

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

const SvgCrossedSword = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Capa_1",
  x: "0px",
  y: "0px",
  viewBox: "0 0 512.002 512.002",
  style: {
    enableBackground: "new 0 0 512.002 512.002"
  },
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("polygon", {
  style: {
    fill: "#A84926"
  },
  points: "381.66,494.016 493.951,381.695 459.036,346.77 346.745,459.092 "
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    fill: "#FFC477"
  },
  points: "455.251,420.405 420.36,455.305 467.044,502.002 501.934,467.101 "
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    fill: "#A84926"
  },
  points: "18.052,381.695 130.343,494.016 165.258,459.092 52.967,346.77 "
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    fill: "#FFC477"
  },
  points: "56.752,420.405 10.068,467.101 44.959,502.002 91.643,455.305 "
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
  style: {
    fill: "#81B4A7"
  },
  points: "167.522,108.467 79.891,20.812 10.068,10.002 20.875,79.843 93.86,152.848  "
}), /*#__PURE__*/React.createElement("polyline", {
  style: {
    fill: "#81B4A7"
  },
  points: "341.839,400.894 373.383,432.447 432.398,373.415 392.227,333.233  "
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
  style: {
    fill: "#B0DBD0"
  },
  points: "119.775,333.233 79.605,373.415 138.62,432.447 170.164,400.894  "
}), /*#__PURE__*/React.createElement("polyline", {
  style: {
    fill: "#B0DBD0"
  },
  points: "418.143,152.848 491.128,79.843 501.934,10.002 432.112,20.812 343.659,109.289  "
})), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#2C7B7E"
  },
  d: "M256.001,454.825c-42.135-14.844-82.413-46.097-114.175-88.789 c-30.725-41.308-46.966-90.364-46.966-141.862v-97.315c43.968-4.285,85.621-18.593,124.157-42.692 c15.251-9.541,27.504-19.081,36.725-26.988c26.675,24.11,78.749,62.433,161.401,69.804v97.191 c0,51.498-16.241,100.554-46.968,141.865C338.418,408.725,298.148,439.975,256.001,454.825z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#C6C5CA"
  },
  d: "M153.809,309.392c-12.651-26.412-19.225-55.317-19.225-85.215v-63.313 c36.99-7.887,72.352-22.28,105.49-43.01c5.104-3.188,10.129-6.526,15.064-9.983c20.059,14.671,41.459,26.69,64.13,36.017"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#C6C5CA"
  },
  d: "M377.419,198.502v25.675c0,42.891-13.525,83.745-39.115,118.143 c-23.475,31.557-52.293,55.873-82.302,69.67c-19.513-8.97-38.51-22.379-55.878-39.345"
})), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#F6DAB9"
  },
  d: "M377.419,161.39v33.911L200.124,372.645c-9.344-9.128-18.212-19.29-26.434-30.325 c-7.756-10.43-14.399-21.445-19.88-32.928l165.459-165.504C337.817,151.526,357.221,157.377,377.419,161.39z"
}), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCrossedSword, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/crossedSword.d8a60ea9.svg";
export { ForwardRef as ReactComponent };